const checkReviewContent = () => {
  if ($('.product-review-block .content-desc-block .content .content-detail, .review-pickup .content-block').length > 0) {
    $.each($('.product-review-block .content-desc-block .content .content-detail, .review-pickup .content-block'), (idx, el) => {
      let overLength = $(el).data('max-length') ?  $(el).text().length > +$(el).data('max-length') : false
      if (el.scrollHeight > el.clientHeight || overLength ) {
        $(`#${$(el).attr('data-rid')}more-content`).css("display","block")
      }
    })
  }
}




$(document).ready(function(){
  checkReviewContent()
  if ($('.list-group-item .list-main-mobile-items').length > 0) {
    $('.list-group-item .list-main-mobile-items').on('click', function(e) {
      switch (e.target.className.split(" ")[0]) {
        case "list-main-btn":
          $(e.target.parentElement).toggleClass('active')
          break;
        case "menu-arrow":
          $(e.target.parentElement).toggleClass('active')
          break;
        default:
          $(e.target).toggleClass('active')
          break;
      }
    })
  }

  $('.tips-note').tooltip({show: null, tooltipClass: "tooltips-block"});

  $('.product_upgrate_cover .close-btn').click(function(){
    $('.product_upgrate_cover').remove();
  });
})


$(window).on('load', function() {
  function send_ga4_event(obj, eventName) {
    let dimensions = {};
    let domName    = '';
    let location   = obj.data('location') || '';
    let directTo   = obj.data('direct-to') || 'none';
    let beautynewsId = obj.data(domName + 'beautynews-id') || '';
    let activityId   = obj.data(domName + 'activity-id') || '';
    let brandId      = obj.data(domName + 'brand-id') || '';
    let productId    = obj.data(domName + 'product-id') || '';
    let reviewId     = obj.data(domName + 'review-id') || '';
    let campaignGroup = obj.data('campaign-group') || '';

    if (location.length > 0) {
      dimensions.location = location;
    }

    if (directTo.length > 0) {
      dimensions.direct_to = directTo;
    }

    if (beautynewsId > 0) {
      dimensions.beautynews_id = beautynewsId;
    }

    if (activityId > 0) {
      dimensions.activity_id = activityId;
    }

    if (brandId > 0) {
      dimensions.brand_id = brandId;
    }

    if (productId > 0) {
      dimensions.product_id = productId;
    }

    if (reviewId > 0) {
      dimensions.review_id = reviewId;
    }

    if (campaignGroup.length > 0) {
      dimensions.campaign_group = campaignGroup;
    }

    gtag('event', eventName + "_ga4", dimensions);
  }

  $(document).on("click", "[data-ga='true']", function() {
    let eventName = $(this).data('event-name') || 'click';
    send_ga4_event($(this), eventName);
  });
})